import "./App.css";
// import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Main from "./pages/Main";
import { useState } from "react";
import Tomviz from "./pages/Tomviz";
import Mulviz from "./pages/Mulviz";
import Vitviz from "./pages/Vitviz";
import Araviz from "./pages/Araviz";
import Cannaviz from "./pages/Cannaviz";
import Chlamviz from "./pages/Chlamviz";

function App() {
  const [colorBg, setColorBg] = useState('bg-lime-900');
  const [logoHeader, setLogoHeader] = useState('/PlantViz_images/Asset_5.svg');
  const [showSpecies, setShowSpecies] = useState(true);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout colorBg={colorBg} logoHeader={logoHeader} showSpecies={showSpecies} setShowSpecies={setShowSpecies} />}>
          <Route index element={<Main />} />
          <Route path="vitviz" element={<Vitviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
          <Route path="tomviz" element={<Tomviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
          <Route path="mulviz" element={<Mulviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
          <Route path="araviz" element={<Araviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
          <Route path="cannaviz" element={<Cannaviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
          <Route path="chlamviz" element={<Chlamviz colorBg={colorBg} setColorBg={setColorBg} setLogoHeader={setLogoHeader} setShowSpecies={setShowSpecies} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
